"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
function Avatar(_a) {
    var uri = _a.uri, size = _a.size, className = _a.className;
    var b = config_1.block("avatar");
    var style = {
        width: size,
        height: size,
    };
    if (!uri)
        return null;
    return react_1.default.createElement("img", { className: b({}).mix(className), style: style, src: uri, loading: "lazy" });
}
exports.default = Avatar;
//# sourceMappingURL=index.js.map